import React from 'react'
import { Grid, TextField, makeStyles } from '@material-ui/core'
// For reference, all stripe elements exported:
//  CardElement, CardNumberElement, CardExpiryElement, CardCvcElement, CardCVCElement,
//  PaymentRequestButtonElement, IbanElement, IdealBankElement, FpxBankElement, AuBankAccountElement
import {
    CardElement
} from 'react-stripe-elements'
import InputComponentWrapper from './InputComponentWrapper'

interface CreditCardFormProps {
    disabled: boolean
}

const useStyles = makeStyles(() => {
    return {
        creditCardField: {
            '& .MuiFilledInput-root': {
                backgroundColor: 'transparent !important',
                '&:hover': {
                    backgroundColor: 'transparent !important',
                    boxShadow: 'inset 0 0 1px 2px #8C8C8C !important'
                },
                '&.Mui-focused': {
                    backgroundColor: 'transparent !important',
                    boxShadow: 'inset 0 0 1px 2px #404040 !important'
                },
                '&::before, &::after': {
                    borderColor: 'transparent !important'
                },
                color: '#1A1A1A !important',
                padding: '8px 10px 8px 14px',
                fontSize: '13px !important',
                boxShadow: 'inset 0 0 1px 1px #8C8C8C',
                boxSizing: 'border-box',
                transition: 'box-shadow 0.2s',
                fontFamily: 'Inter, Montserrat, Helvetica, arial, sans-serif !important',
                fontWeight: '400',
                lineHeight: '21px',
                borderRadius: '6px',
                letterSpacing: '-0.1px',
                '& .MuiFilledInput-input': {
                    padding: 0
                }
            }
        }
    }
})

/**
 * Form to collect credit card + billing address as part of the sign-up checkout process
 */
const CreditCardForm = ({ disabled } : CreditCardFormProps) : JSX.Element => {
    const classes = useStyles()

    return (
        <Grid container spacing={3}>
            {/* Important: for future development it is recommended to switch to Stripe's PaymentElement (and upgrade to @stripe/react-stripe-js to do so)
                alternatively, it is possible to use individuallized elements like: CardNumberElement, CardCVCElement, CardExpiryElement
                however CardElement provides all this + postal code (which pops in as needed) */}
            <Grid item xs={12}>
                <TextField
                    data-testid="credit-card-field"
                    variant="filled"
                    label='' // leave blank as these would float over stripe's input labels
                    className={classes.creditCardField}
                    required
                    fullWidth
                    disabled={disabled}
                    InputProps={{
                        inputComponent: InputComponentWrapper,
                        inputProps: {
                            component: CardElement
                        }
                    }}
                />
            </Grid>
        </Grid>
    )
}

export default CreditCardForm
